export function detectMobile(): boolean {
  return (window.innerWidth <= 600);
}
